module.exports = __webpack_public_path__ + "static/media/banner_s_06.cc933ba4.jpg";